/* eslint-disable */
require('./Archive')
require('./Archive2')
require('./Arrow-right')
require('./ArrowArcLeft')
require('./ArrowArcRight')
require('./ArrowCounterClockwise')
require('./ArrowDown')
require('./Backward')
require('./Backward1')
require('./Backward10')
require('./Backward1sec')
require('./Bar-chart')
require('./Brand-sum')
require('./Brand-summary')
require('./Brand-video')
require('./Brand-videocam')
require('./CategoryCubes')
require('./CategoryLines')
require('./Chevron-left')
require('./Chevron-left2')
require('./Chevron-right')
require('./Clock')
require('./Close')
require('./CloudCheck')
require('./CloudSlash')
require('./crop')
require('./Cut')
require('./Cut2')
require('./Delete')
require('./Done-all')
require('./Done')
require('./Download')
require('./Download2')
require('./Download3')
require('./Edit')
require('./Edit2')
require('./Error')
require('./File-upload')
require('./Filter')
require('./FilterClose')
require('./FilterOpen')
require('./Folder')
require('./Folder2')
require('./Forward')
require('./Forward1')
require('./Forward10')
require('./Forward1sec')
require('./Heatmap')
require('./Info')
require('./Logo-squares')
require('./More')
require('./More2')
require('./pause_circle_fill')
require('./Pause')
require('./Pause2')
require('./Play')
require('./Plus')
require('./Report-chart')
require('./Report-chart2')
require('./save')
require('./Search')
require('./Setting')
require('./sharp')
require('./SignIn')
require('./Success')
require('./Union')
require('./Video_Analytics')
require('./Warning')
